// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeAccountApi = class EdgeAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param iActivateUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountActivateUser(iActivateUserRequestModel, xProgramId) {
        const _url_ = '/edge/account/ActivateUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iActivateUserRequestModel' is not null or undefined
        if (iActivateUserRequestModel === null || iActivateUserRequestModel === undefined) {
            throw new Error('Required parameter iActivateUserRequestModel was null or undefined when calling accountActivateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iActivateUserRequestModel, "IActivateUserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountActivateUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountGetPrescribers(body, xProgramId) {
        const _url_ = '/edge/account/GetPrescribers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetPrescribers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetPrescribersDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountGetSites(body, xProgramId) {
        const _url_ = '/edge/account/GetSites';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetSites.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetSitesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param iGetTasksRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountGetTasks(iGetTasksRequestModel, xProgramId) {
        const _url_ = '/edge/account/GetTasks';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iGetTasksRequestModel' is not null or undefined
        if (iGetTasksRequestModel === null || iGetTasksRequestModel === undefined) {
            throw new Error('Required parameter iGetTasksRequestModel was null or undefined when calling accountGetTasks.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iGetTasksRequestModel, "IGetTasksRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetTasksDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountGetUsers(body, xProgramId) {
        const _url_ = '/edge/account/GetUsers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling accountGetUsers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountGetUsersDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param removePrescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountRemovePrescriber(removePrescriberRequestModel, xProgramId) {
        const _url_ = '/edge/account/RemovePrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'removePrescriberRequestModel' is not null or undefined
        if (removePrescriberRequestModel === null || removePrescriberRequestModel === undefined) {
            throw new Error('Required parameter removePrescriberRequestModel was null or undefined when calling accountRemovePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(removePrescriberRequestModel, "RemovePrescriberRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountRemovePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param removeSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountRemoveSite(removeSiteRequestModel, xProgramId) {
        const _url_ = '/edge/account/RemoveSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'removeSiteRequestModel' is not null or undefined
        if (removeSiteRequestModel === null || removeSiteRequestModel === undefined) {
            throw new Error('Required parameter removeSiteRequestModel was null or undefined when calling accountRemoveSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(removeSiteRequestModel, "RemoveSiteRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountRemoveSiteDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param prescriberUpsearchModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountSavePrescriber(prescriberUpsearchModel, xProgramId) {
        const _url_ = '/edge/account/SavePrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberUpsearchModel' is not null or undefined
        if (prescriberUpsearchModel === null || prescriberUpsearchModel === undefined) {
            throw new Error('Required parameter prescriberUpsearchModel was null or undefined when calling accountSavePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberUpsearchModel, "PrescriberUpsearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSavePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param siteUpsearchModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountSaveSite(siteUpsearchModel, xProgramId) {
        const _url_ = '/edge/account/SaveSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteUpsearchModel' is not null or undefined
        if (siteUpsearchModel === null || siteUpsearchModel === undefined) {
            throw new Error('Required parameter siteUpsearchModel was null or undefined when calling accountSaveSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteUpsearchModel, "SiteUpsearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveSiteDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param noteTaskCreateModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountSaveTask(noteTaskCreateModel, xProgramId) {
        const _url_ = '/edge/account/SaveTask';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'noteTaskCreateModel' is not null or undefined
        if (noteTaskCreateModel === null || noteTaskCreateModel === undefined) {
            throw new Error('Required parameter noteTaskCreateModel was null or undefined when calling accountSaveTask.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(noteTaskCreateModel, "NoteTaskCreateModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveTaskDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param scriptsAccountSaveUserSaveUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountSaveUser(scriptsAccountSaveUserSaveUserRequestModel, xProgramId) {
        const _url_ = '/edge/account/SaveUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsAccountSaveUserSaveUserRequestModel' is not null or undefined
        if (scriptsAccountSaveUserSaveUserRequestModel === null || scriptsAccountSaveUserSaveUserRequestModel === undefined) {
            throw new Error('Required parameter scriptsAccountSaveUserSaveUserRequestModel was null or undefined when calling accountSaveUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsAccountSaveUserSaveUserRequestModel, "ScriptsAccountSaveUserSaveUserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param iSaveUserRoleRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountSaveUserRole(iSaveUserRoleRequestModel, xProgramId) {
        const _url_ = '/edge/account/SaveUserRole';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iSaveUserRoleRequestModel' is not null or undefined
        if (iSaveUserRoleRequestModel === null || iSaveUserRoleRequestModel === undefined) {
            throw new Error('Required parameter iSaveUserRoleRequestModel was null or undefined when calling accountSaveUserRole.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iSaveUserRoleRequestModel, "ISaveUserRoleRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountSaveUserRoleDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param accountSaveModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountUpdateAccount(accountSaveModel, xProgramId) {
        const _url_ = '/edge/account/UpdateAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountSaveModel' is not null or undefined
        if (accountSaveModel === null || accountSaveModel === undefined) {
            throw new Error('Required parameter accountSaveModel was null or undefined when calling accountUpdateAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountSaveModel, "AccountSaveModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountUpdateAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param saveThirdPartyIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async externalIdSaveThirdPartyId(saveThirdPartyIdRequestModel, xProgramId) {
        const _url_ = '/edge/account/ExternalId/saveThirdPartyId';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'saveThirdPartyIdRequestModel' is not null or undefined
        if (saveThirdPartyIdRequestModel === null || saveThirdPartyIdRequestModel === undefined) {
            throw new Error('Required parameter saveThirdPartyIdRequestModel was null or undefined when calling externalIdSaveThirdPartyId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(saveThirdPartyIdRequestModel, "SaveThirdPartyIdRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse");
        }
        return response;
    }
    /**
     *
     * @param prescribersRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async prescribersHubGetPrescribers(prescribersRequestModel, xProgramId) {
        const _url_ = '/edge/account/v2/Prescribers/HubGetPrescribers';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescribersRequestModel' is not null or undefined
        if (prescribersRequestModel === null || prescribersRequestModel === undefined) {
            throw new Error('Required parameter prescribersRequestModel was null or undefined when calling prescribersHubGetPrescribers.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescribersRequestModel, "PrescribersRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse");
        }
        return response;
    }
    /**
     *
     * @param siteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async sitesHubGetSites(siteRequestModel, xProgramId) {
        const _url_ = '/edge/account/v2/Sites/HubGetSites';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteRequestModel' is not null or undefined
        if (siteRequestModel === null || siteRequestModel === undefined) {
            throw new Error('Required parameter siteRequestModel was null or undefined when calling sitesHubGetSites.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteRequestModel, "SiteRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AccountV2SitesHubGetSitesHubGetSitesResponse");
        }
        return response;
    }
};
EdgeAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeAccountApi);
export { EdgeAccountApi };
//# sourceMappingURL=edgeAccountApi.js.map